import { createFileRoute } from "@tanstack/react-router"
import InspectorPlayground from "~/pages/design-system/pages/InspectorPlayground"

export const Route = createFileRoute("/_auth/internal/design-system/pages/inspector")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <InspectorPlayground />
}
